import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueRouter from 'vue-router'
import Vuex from 'vuex'
import Mint from 'mint-ui'
import 'mint-ui/lib/style.css'
import { Toast } from 'mint-ui'
import VueClipboard from 'vue-clipboard2'
import utilAPI from './utils/publicAPI'
import $utils from './utils/index.js?v=1.0'
import Bridge from './utils/bridge.js?v=1.0'

// 加载router配的标题
router.beforeEach((to, from, next) => {
  document.title = to.meta.title
  next()
})

Vue.use(Mint)
Vue.use(VueRouter)
Vue.use(utilAPI)
Vue.use(Vuex)
Vue.use(VueClipboard)

// 将公共方法绑定到全局
Vue.prototype.axios = axios
Vue.prototype.$utils = $utils
Vue.prototype.$bridge = Bridge

// 测试环境地址
axios.defaults.timeout = 30000
axios.defaults.withCredentials = true
// let rootUrl = 'http://ifreabsms1.chinacloudapp.cn'
let rootUrl = 'https://www.ibaner.com.cn'
window.rootUrl = rootUrl
// Add a request interceptor
axios.interceptors.request.use(function (config) {
  window.banner_uid = localStorage.banner_uid
  window.banner_token = localStorage.banner_token
  let url = config.url || ''
  let code = url.substring(10, 14) || ''
  // Do something before request is sent
  config.headers['Content-Type'] = 'application/json'
  config.headers['Cache-Control'] = 'no-cache'
  config.headers['_tm'] = new Date().getTime()
  config.headers['_cn'] =  sessionStorage.banner_channel || '00'
  config.headers['versionNumber'] = '1.0.1'
  config.headers['_si'] = code
  // 积分接口07传APP或第三方登录信息
  if (code.substring(0, 2) === '07' || code === '0000' || code === '0001') {
    config.headers['_tn'] = window.banner_token || ''
    config.headers['_ui'] = window.banner_uid || ''
  } else {
    let _token = window.banner_token || ''
    let _uid = window.banner_uid || ''
    let _openid = localStorage.openid || ''
    config.headers['_tn'] = _token || ''
    config.headers['_ui'] = _uid || ''
    config.headers['_ci'] = _openid || ''
  }
  // 是否开启AES加密 openEncrypt 为0开启加密
  if (!$utils.isnull(config.data) && sessionStorage.openEncrypt === '0') {
    // 系数（前后端提前约定好）
    let decIv = '0102030405060708'
    // 1.对明文进行加签（就是 对明文（报文+系数）做md5加密）
    let singStr = window.md5(JSON.stringify(config.data) + decIv).toUpperCase()
    // 对明文报文做AES加密,再做转换成base64流
    let axiosData = JSON.stringify(config.data)
    let eDataAes = window.encrypt(axiosData)
    let eData = eDataAes.toString()
    config.data = { 'dataSign': singStr, 'dataReq': eData }
  }
  return config
}, function (error) {
  return Promise.reject(error)
})
// 拦截未登录
axios.interceptors.response.use(function (res) {
  // Do something with response data
  let response = ''
  if (res.config.headers._si === '0000' || res.config.headers._si === '1003') {
    response = res
    return response
  } else {
    // AES解密  是否开启解密
    if (sessionStorage.openEncrypt === '0') {
      let resData = res.data.dataResp
      response = {data: JSON.parse(window.decrypt(resData))}
    } else {
      response = res
    }
    let _resrd
    if (!$utils.isnull(response.data.appid)) {
      _resrd = ''
    } else {
      _resrd = response.data.head._rd
    }
    let _resrm = response.data.head._rm
    let url = document.URL
    // 0001 8002 8003 未登录  8001 刷新token
    if (_resrd === '0001' || _resrd === '8002' || _resrd === '8003' || _resrd === '8000') {
      var hash = location.hash
      if (hash.indexOf('return_url') === -1) {
        if (url.indexOf('localhost') !== -1) {
          location.href = 'http://localhost:8080/#/Login/Login'
        } else {
          location.href = window.rootUrl + '/#/Login/Login'
        }
      }
    } else if (_resrd === '8001') {
      this.axios.post('/baner/00_0002.do')
        .then(function (res) {
          let state = res.data.head._rd
          if (state === '0000') {
            let token = res.data.body.newToken
            localStorage.setItem('token', token)
            return token
          }
        })
        .catch(function (error) {
          console.log(error)
        })
      // 022007 文章已经被删除，该错误在详细页面处理，这里不做拦截处理 或0123接口
    } else if (_resrd === '022007' || _resrd === '1002' || _resrd === '0003') {
      console.log()
    } else if (_resrd !== '0000') {
      Toast({
        message: _resrm,
        duration: 2000
      })
    }
    return response
  }
}, function (error) {
  let url = document.URL
  if (url.indexOf('localhost') !== -1) {
    location.href = 'http://localhost:8080/#/Error'
  } else {
    location.href = window.rootUrl + '/#/Error'
  }
  // Do something with response error
  return Promise.reject(error)
})
Vue.config.productionTip = false
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js